(function(window){
  class Han {
    constructor(option){
      console.log(option);
      this.content = option.content;
    }

    open(){
      if(!this.modal){
        this.modal = new Modal({ content: this.content });
      }
      this.modal.open();
    }

  }

  class Modal {
    constructor(option){
      this.isInsert = false;
      this.create(option.content);
    }

    create(dom){
      const container = document.createElement("div");
      container.classList.add("han-modal");

      const wrapper = document.createElement("div");
      wrapper.classList.add("han-wrapper");

      const close = document.createElement("div");
      close.classList.add("han-close");
      close.innerHTML = this.closeIcon;
      close.onclick = () => {
        this.close();
      }
      
      const content = document.createElement("div");
      content.classList.add("han-content");
      content.append(dom);

      wrapper.append(close);
      wrapper.append(content);

      container.append(wrapper);
      this.modal = container;
    }

    open(){
      if(!this.isInsert){
        document.body.append(this.modal);
        this.isInsert = true;
      }
      this.modal.classList.add("visible");
    }

    close(){
      this.modal.classList.remove("visible");
    }

    get closeIcon(){
      return '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"><path d="M753.792 821.696L538.88 606.72 323.904 821.76 256 753.856l214.976-215.04L256 323.904 323.84 256l215.04 214.976L753.728 256l67.84 67.84L606.72 538.88l214.976 214.912-67.84 67.84z" fill="currentColor"></path></svg>';
    }
  }

  var HanButton = class extends HTMLElement {
    connectedCallback(){
      setTimeout(() => {
        this.question = document.querySelector(".han-question");
        this.han = new Han({ content: this.question });
        // this.han.open();
      }, 500);
      this.onclick = function(){
        if(!this.han){
          if(!this.question){
            this.question = document.querySelector(".han-question");
          }
          this.han = new Han({ content: this.question });
        }
        this.han.open();
      }
    }
  }
  window.customElements.define("han-button", HanButton);

  window.Message = class {
    constructor(content) {
      // 初始内容
      this.initModal(content);
    }

    initModal(){
      // 初始化DOM元素
      this.container = document.createElement('div');
      this.container.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: none;
        align-items: center;
        justify-content: center;
        background-color: none;
        z-index: 9999;
        color: #fff;
        font-size: 20px;
        padding: 20px;
        border-radius: 5px;
        box-sizing: border-box;
      `;
      this.contentElement = document.createElement('div');
      this.contentElement.style.cssText = `
        background: #fff;
        color: #111;
        padding: 10px 18px;
        border-radius: 4px;
        position: absolute;
        top: 50px;
        font-size: 15px;
      `;
      this.container.appendChild(this.contentElement);
      document.body.appendChild(this.container);
    }

    show(content) {
      this.contentElement.textContent = content;
      this.container.style.display = "flex";
      setTimeout(() => {
        this.hide();
      }, 2000);
    }
  
    // 隐藏提示框
    hide() {
      // 移除提示框
      this.container.style.display = "none";
    }
  }

  var HanQuestion = class extends HTMLElement {
    connectedCallback(){
      console.log("han-question初始化完成");
      this.activeIndex = 0;
      this.stepIndex = -1;
      this.formData = {
        "contact[device]": "android"
      };
      this.dataList = window.car_make_model_data;
      this.question_data = question_data.android;
      this.dataObj = this.dataList.reduce((res, cur) => {
        res[cur["Car Make-Model"]] = cur["Year Range"];
        return res;
      }, {});
      console.log(this.dataObj);
      setTimeout(() => {
        this.initClick();
        this.initFormListen();
      }, 10);
      this.message = new Message();
    }
    
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }

    initSelectDataList(el, type){
      console.log(el, type);
      let select_input = el.querySelector(".select input");
      let options_wrapper = el.querySelector(".han-option-wrapper");
      
      if(options_wrapper && this.question_data[type].length){
        const options_items_el = this.question_data[type].map(e => {
          return `<div data-value="${e["Car Make-Model"]}" class="han-option-item">${e["Car Make-Model"]}</div>`;
          // return `<div data-value="${e["Car Make-Model"]}" data-relation="${e["Year Range"]}" class="han-option-item">${e["Car Make-Model"]}</div>`;
        }).join("");
        const options_list_el = this.createElement("div", "han-option-list");
        options_list_el.innerHTML = options_items_el;
        options_wrapper.innerHTML = "";
        options_wrapper.append(options_list_el);
        let options = el.querySelectorAll(".han-option-item");
        if(options){
          select_input.addEventListener("keyup", (event) => {
            options.forEach(e => {
              if(event.target.value){
                if(e.innerText && e.innerText.toLocaleLowerCase().includes(event.target.value.toLocaleLowerCase())){
                  e.style.display = "block";
                }else{
                  e.style.display = "none";
                }
              }else{
                e.style.display = "block";
              }
            });
            if(type == "locomotive"){
              options[options.length - 1].style.display = "block";
            }
          });
          options.forEach(option => {
            option.onclick = (event) => {
              select_input.value = event.target.dataset.value;
              select_input.dataset.relation = event.target.dataset.relation;
              select_input.dispatchEvent(new Event('change', { bubbles: true }));
              select_input.closest("form-item").classList.remove("expand");
            }
          });
        }
      }
    }

    initClick(){
      this.items = document.querySelectorAll("han-question-item");
      this.steps = document.querySelectorAll("step-item");
      document.querySelector("#contact_form").addEventListener('change', (e) => {
        if (e.target.name === 'contact[device]') {
          this.question_data = question_data[e.target.value];
          this.initSelectDataList(document.querySelector(`[data-type="car_model"]`), "car_model");
          this.initSelectDataList(document.querySelector(`[data-type="locomotive"]`), "locomotive");
        }else if(e.target.name === 'contact[is installed]'){
          console.log(e.target.dataset.href);
          e.target.closest("han-question-item").querySelector("han-next").dataset.href = e.target.dataset.href;
        }
      });
      

      

      // 监听这个事件
      document.addEventListener('question:start', (event) => {
        this.next(event.detail.index);
      });
      // 监听这个事件
      document.addEventListener('question:next', (event) => {
        this.next(event.detail.index);
      });
      // 监听这个事件
      document.addEventListener('question:previous', (event) => {
        this.previous(event.detail.index);
      });
      // 监听这个事件
      document.addEventListener('question:success', (event) => {
        this.success();
      });


      if(window.que) return;
      this.items.forEach((el, index) => {
        let nexts = el.querySelectorAll("han-next");
        let previous = el.querySelector("han-previous");
        console.log(el.dataset.type);
        if(el.dataset.type){
          this.initSelectDataList(el, el.dataset.type);
        }
        
        let select_input = el.querySelector(".select input");
        if(select_input){
          select_input.onfocus = (event) => {
            event.target.closest("form-item").classList.add("expand");
          }
          select_input.onblur = (event) => {
            setTimeout(() => event.target.closest("form-item").classList.remove("expand"), 300);
          }
        }
        
        el.querySelectorAll("[name]").forEach(el => { 
          el.addEventListener("change", (event) => {
            this.formData[event.target.getAttribute("name")] = event.target.value;
          });
        });

        if(nexts.length){
          nexts.forEach(next => {
            if(next.dataset.type == "submit"){
              console.log("submit");
              next.addEventListener("click", () => {
                let input = el.querySelector("[name]");
                if(input.getAttribute("type") == "email"){
                  if(!input.value){
                    el.closest("han-question-item").classList.add("error");
                  }else{
                    if(!input.value.match("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$")){
                      el.closest("han-question-item").classList.add("error");
                    }else{
                      el.closest("han-question-item").classList.remove("error");
                      this.mailchimpFormSubmit();
                    }
                  }
                }
              })
            }else{
              console.log("非submit");
              next.addEventListener("click", () => {
                // const input = el.querySelector("[name]");
                let res = true;
                let inputs = el.querySelectorAll("[name]");
                if(inputs.length){
                  if(next.dataset.valid != "false"){
                    inputs.forEach(input => {
                      if(input.getAttribute("type") == "radio"){
                        if(!el.querySelector("[name]:checked")){
                          input.closest("form-item").classList.add("error");
                          res = false;
                        }else{
                          input.closest("form-item").classList.remove("error");
                        }
                      }else if(input.getAttribute("type") == "email"){
                        if(!input.value){
                          input.closest("form-item").classList.add("error");
                          res = false;
                        }else{
                          if(!input.value.match("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$")){
                            input.closest("form-item").classList.add("error");
                            res = false;
                          }else{
                            input.closest("form-item").classList.remove("error");
                          }
                        }
                      }else{
                        if(!input.value){
                          input.closest("form-item").classList.add("error");
                          res = false;
                        }else{
                          input.closest("form-item").classList.remove("error");
                        }
                      }
                    });
                  }
                  if(next.dataset.callback == "system_isnt"){
                    this.formData["contact[aftermarket]"] = "My system isn’t listed";
                  }
                  if(res){
                    this.next(Number(next.dataset.href) || index, index + 1);
                  }
                }else{
                  this.next(Number(next.dataset.href) || index, index + 1);
                }
              });
            }
          });
        }
        if(previous){
          previous.addEventListener("click", () => {
            this.previous(Number(previous.dataset.href) || index);
          });
        }
      });
    }

    next(index, previousIndex){
      console.log("下一步", index);
      this.activeIndex = index + 1;

      for (let i = 0; i <= index; i++) {
        this.items[i].classList.remove("active");
      }
      // this.items[index].classList.remove("active");
      this.items[index + 1].classList.add("active");
      this.items[index + 1].querySelector("han-previous").dataset.href = previousIndex;
      
      const stepIndex = this.items[index + 1].dataset.step;
      for (let i = 0; i < stepIndex; i++) {
        this.steps[i].classList.remove("active");
        this.steps[i].classList.add("pass");
      }
      this.steps[stepIndex].classList.add("active");

      if(this.activeIndex > 0){
        this.showStep();
      }

      if(this.activeIndex == this.items.length - 1){
        this.steps[this.steps.length - 1].classList.add("pass");
      }
    }

    previous(index){
      console.log("上一步", index);
      this.activeIndex = index - 1;
      
      for (let i = this.items.length - 1; i > index; i--) {
        this.items[i].classList.remove("active");
      }
      this.items[index - 1].classList.add("active");

      
      const stepIndex = this.items[index - 1].dataset.step;
      console.log("stepIndex===", stepIndex);
      for (let i = this.steps.length - 1; i > stepIndex; i--) {
        this.steps[i].classList.remove("active");
        this.steps[i - 1].classList.remove("pass");
      }
      this.steps[stepIndex].classList.add("active");

      if(this.activeIndex < 1){
        this.hideStep();
      }
    }

    initFormListen(){
      const _this = this;
      // document.querySelector("#mce-error-response").addEventListener("DOMNodeInserted", function(){
      //   _this.message.show(this.innerText);
      // });
      // document.querySelector("#mce-success-response").addEventListener("DOMNodeInserted", function(){
      //   _this.success();
      // });
      document.querySelector("#mc_embed_shell").addEventListener("DOMNodeInserted", function(){
       console.log("成功容器内容变化");
       console.log("success", document.querySelector("#mce-success-response").style.display);
       console.log("error", document.querySelector("#mce-error-response").style.display);
       if(document.querySelector("#mce-success-response").style.display == "block"){
        console.log("成功");
         _this.success();
         setTimeout(() => {
          document.querySelector("#mce-success-response").style.display = "none";
          document.querySelector("#mce-success-response").innerText = "";
         }, 1000);
       }else if(document.querySelector("#mce-error-response").style.display == "block"){
        console.log("失败", document.querySelector("#mce-error-response").innerText);
        _this.message.show(document.querySelector("#mce-error-response").innerText);
        setTimeout(() => {
         document.querySelector("#mce-error-response").style.display = "none";
         document.querySelector("#mce-error-response").innerText = "";
        }, 1000);
       }
      });
    }

    static field_map = {
      "contact[name]": "MMERGE11",
      "contact[device]": "MMERGE27",
      "contact[car]": "MMERGE25",
      "contact[is installed]": "MMERGE28",
      "contact[aftermarket]": "MMERGE29",
      "contact[email]": "EMAIL"
    }
    
    mailchimpFormSubmit(){
      console.log("数据提交：", this.formData);
      const _this = this;
      let formKeys = Object.keys(this.formData);
      formKeys.forEach((key) => {
        document.querySelector(`[name='${ HanQuestion.field_map[key] }']`).value = this.formData[key];
      });
      // let inputList = document.querySelectorAll(".mc-field-group input[name]");
      // inputList.forEach((el, index) => {
      //   el.value = this.formData[formKeys[index]];
      //   el.dispatchEvent(new Event('change', { bubbles: true }));
      // });
      document.querySelector('#mc_embed_signup [type="submit"]').click();
    }

    success(){
      this.items.forEach(e => {
        e.classList.remove("active");
      });
      this.steps.forEach(e => {
        e.classList.add("pass");
        e.classList.remove("active");
      });
      console.log(this.formData);

      if(this.formData["contact[aftermarket]"] == "My system isn’t listed" || this.formData["contact[is installed]"] == "no"){
        // 失败
        document.querySelector("[data-result-text]").innerText = "Unfortunately, your car doesn't support the wireless features of our Hexacharge product. However, we'll make sure to notify you via email as soon as we have a product that fits your needs.";
        document.querySelector(".returnto.success").style.display = "none";
        document.querySelector(".returnto.fail").style.display = "block";
      }else{
        document.querySelector("[data-result-text]").innerText = "Great news! Your car is compatible with Hexacharge. Purchase Hexacharge now and enjoy seamless connectivity on the go!";
        document.querySelector(".returnto.success").style.display = "block";
        document.querySelector(".returnto.fail").style.display = "none";
      }

      this.items[this.items.length - 1].classList.add("active");
    }

    showStep(){
      if(!this.stepEl){
        this.stepEl = document.querySelector("han-question-step");
      }
      this.stepEl.classList.add("active");
    }

    hideStep(){
      if(!this.stepEl){
        this.stepEl = document.querySelector("han-question-step");
      }
      this.stepEl.classList.remove("active");
    }

    createElement(node, classes, text){
      if(!node) return;
      const el = document.createElement(node);
      if(typeof classes === 'object' && classes instanceof Array){
        classes.forEach(className => {
          el.classList.add(className);
        });
      }else if(classes){
        el.classList.add(classes);
      }
      if(text){
        el.innerText = text;
      }
      return el;
    }

    tmpl(){
      console.log("替换模板数据");
      if(!this.labels)
        this.labels = document.querySelectorAll("[data-han-content]");
      this.labels.forEach(label => {
        let content = label.dataset.text;
        Object.keys(this.formData).forEach(key => {
          content = content.replace("${" + key + "}", this.formData[key]);
        });
        label.innerText = content;
      });
    }
  }
  window.customElements.define("han-question", HanQuestion);

  const isDOM = ( typeof HTMLElement === 'object' ) ? function(obj){ return obj instanceof HTMLElement; } : function(obj){ return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string'; }

  window.Question = class {
    constructor(option){
      this.container = isDOM(option.el) ? option.el : document.querySelector(option.el);
      this.data = option.data;
      this.formData = {};
      this.createQuestion();
    }

    initForm(){
      this.contact = document.querySelector("#contact_form");
      const wrap = document.createElement("div");
      this.contact.append(wrap);
      let html = "";
      Object.keys(this.formData).forEach(key => {
        html += `<input type="text" name="contact[${key}]" value="${this.formData[key]}">`;
      });
      wrap.innerHTML = html;
      this.submitForm();
    }

    get tipsIcon (){
      return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--bx" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm3.293 14.707L11 12.414V6h2v5.586l3.707 3.707l-1.414 1.414z" fill="currentColor"></path></svg>';
    }

    get passIcon (){
      return '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" preserveAspectRatio="xMidYMid meet" aria-hidden="true" role="img"><path d="M9.99997 15.586L6.70697 12.293L5.29297 13.707L9.99997 18.414L19.707 8.70697L18.293 7.29297L9.99997 15.586Z" fill="currentColor"></path></svg>';
    }

    createQuestion(){
      const question = document.createElement("han-question");
      question.classList.add("han-question");

      const questionStep = document.createElement("han-question-step");
      const items = [];

      this.labels = [];
      
      this.data.forEach((item, index) => {
        questionStep.append(this.createStep(item, index));
        items.push(this.createItem(item, index));
      });
      question.append(questionStep);
      items.forEach(e => {
        question.append(e);
      });
      this.container.append(question);
    }

    createStep(item, index){
      let stepItem = null, stepIndex = null;
      if(item.type == 'start'){
        return this.createElement("step-item", "hide");
      }else if(item.type == 'question' || item.type == 'result' || item.type == 'submit'){
        stepItem = this.createElement("step-item");
        stepIndex = this.createElement("step-index");
        stepIndex.innerHTML = `<span>${index}</span>${this.passIcon}`;
        stepItem.append(stepIndex);
        stepItem.append(this.createElement("div", "", item.stepName));
        return stepItem;
      }
    }
    
    tmpl(){
      console.log("替换模板数据");
      this.labels.forEach(label => {
        let content = label.dataset.text;
        Object.keys(this.formData).forEach(key => {
          console.log("${" + key + "}");
          content = content.replace("${" + key + "}", this.formData[key]);
        });
        label.innerText = content;
      });
    }

    createItem(item, index){
      let questionItem = null;
      if(item.type == "start"){
        questionItem = this.createElement("han-question-item", index == 0 ? ["han-question-start", "active"] : "han-question-start");
        questionItem.append(this.createElement("h2", "title", item.title));
        let start = this.createElement("han-next", "", "Start");
        start.onclick = () => {
          console.log("开始");
          document.dispatchEvent(new CustomEvent('question:start', { detail: { index } }));
        }
        questionItem.append(start);
        
        if(item.tips){
          let tips = this.createElement("div", "tips");
          tips.innerHTML = `${this.tipsIcon}<span>${item.tips}</span>`;
          questionItem.append(tips);
        }
        return questionItem;
      }
      if(item.type == 'question' || item.type == 'submit'){
        questionItem = this.createElement("han-question-item");
        questionItem.append(this.createElement("h2", "title", item.title));
        let formItem = this.createElement("form-item");
        let label = this.createElement("div", "label", item.label);
        label.setAttribute("data-text", item.label);
        this.labels.push(label);
        formItem.append(label);
        
        if(item.field){
            let field = this.createElement("div", item.field.type);
            if(item.field.type == "input"){
              field.innerHTML = `<input type="text" name="${item.field.key}" placeholder="${item.field.placeholder}">`;
            }else if(item.field.type == "select"){
              // field.innerHTML = `<select name="${item.field.key}" placeholder="${item.field.placeholder}">${item.field.options.map(e => `<option value="${e.value}">${e.name}</option>`).join("")}</select>`;
              field.innerHTML = `
                <input type="text" name="${item.field.key}" placeholder="${item.field.placeholder}">
                <div class="han-option-wrapper"><div class="han-option-list">${item.field.options.map(e => `<div data-value="${e.value}" data-relation="${e.relation}" class="han-option-item">${e.name}</div>`).join("")}</div></div>
              `;
              let input = field.querySelector(`[name="${item.field.key}"]`);
              let options = field.querySelectorAll(".han-option-item");
              input.onfocus = () => {
                formItem.classList.add("expand");
              }
              input.addEventListener("keyup", (event) => {
                console.log(event.target.value);
                options.forEach(e => {
                  if(event.target.value){
                    if(e.innerText && e.innerText.toLocaleLowerCase().includes(event.target.value.toLocaleLowerCase())){
                      e.style.display = "block";
                    }else{
                      e.style.display = "none";
                    }
                  }else{
                    e.style.display = "block";
                  }
                });
              });
              options.forEach(option => {
                option.onclick = (event) => {
                  input.value = event.target.dataset.value;
                  input.dataset.relation = event.target.dataset.relation;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                  formItem.classList.remove("expand");
                }
              });
            }else if(item.field.type == "radio"){
              field.innerHTML = item.field.options.map(e => `<input type="radio" id="${e.name}" name="${item.field.key}" value="${e.value}" class="hide" /><label for="${e.name}">${e.name}</label>`).join("");
            }
            field.querySelectorAll("[name]").forEach(el => { 
              el.addEventListener("change", (event) => {
                console.log("输入框数据变化：", event.target.value);
                this.formData[event.target.getAttribute("name")] = event.target.value;
                if(item.field.relation){
                  this.formData[item.field.relation] = event.target.dataset.relation;
                }
                console.log(this.formData);
              });
            });
            formItem.append(field);
        }
        formItem.append(this.createElement("div", "error-text", item.field.error));
        questionItem.append(formItem);
        let control = this.createElement("div", "control");
        let previous = this.createElement("han-previous", "", "Previous");
        previous.onclick = () => {
          console.log("上一步");
          document.dispatchEvent(new CustomEvent('question:previous', { detail: { index } }));
        }
        control.append(previous);
        let next = this.createElement("han-next", "", item.type == 'submit' ? "Submit" : "Okay!");
        next.onclick = () => {
          console.log("下一步");
          console.log(this.formData);
          if(item.field.required && !this.formData[item.field.key]){
            questionItem.classList.add("error");
            return;
          }
          if(item.field.regex && !this.formData[item.field.key].match(item.field.regex)){
            questionItem.classList.add("error");
            return;
          }
          questionItem.classList.remove("error");
          if(item.type == "submit"){
            this.initForm();
          }else{
            this.tmpl();
            document.dispatchEvent(new CustomEvent('question:next', { detail: { index } }));
          }
        }
        control.append(next);
        questionItem.append(control);
        return questionItem;
      }
      if(item.type == 'result'){
        questionItem = this.createElement("han-question-item", "han-question-result");
        questionItem.innerHTML = `<h2>${item.title}</h2>
        <div class="label">${item.label}</div>
        <a href="${item.returnto}" class="returnto">${item.button}</a>`;
        return questionItem;
      }
    }

    createElement(node, classes, text){
      if(!node) return;
      const el = document.createElement(node);
      if(typeof classes === 'object' && classes instanceof Array){
        classes.forEach(className => {
          el.classList.add(className);
        });
      }else if(classes){
        el.classList.add(classes);
      }
      if(text){
        el.innerText = text;
      }
      return el;
    }

    submitForm(){
      this.contact.submit();
    }

  }

})(window, document);

document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector("#question-container");
  if(!container) return;
  window.que = new Question({
    el: container,
    data: [
      {
        type: "start",
        stepName: "Your Name",
        title: "Welcome! Let's Get Started",
        tips: "Takes 1 minute 15 seconds"
      },
      {
        type: "question",
        stepName: "Your Name",
        title: "What's your name?",
        label: "Please enter your name",
        field: {
          key: "name",
          type: "input",
          placeholder: "Please enter your name",
          required: true,
          error: "This field is required"
        }
      },
      {
        type: "question",
        stepName: "Year Car",
        title: "Help us find your car",
        label: "Select your car's make and model from the dropdown list below. If you don’t see your car, click the button below",
        field: {
          key: 'car',
          type: "select",
          options: [
            { id: "0", name: "", value: "" },
            { id: "1", name: "aaa", value: "aaa", relation: "2001" },
            { id: "2", name: "bbb", value: "bbb", relation: "2002" },
            { id: "3", name: "ccc", value: "ccc", relation: "2003" },
            { id: "4", name: "ddd", value: "ddd", relation: "2004" },
            { id: "5", name: "eee", value: "eee", relation: "2005" },
            { id: "6", name: "fff", value: "fff", relation: "2006" },
            { id: "7", name: "ggg", value: "ggg", relation: "2007" },
            { id: "8", name: "hhh", value: "hhh", relation: "2008" },
            { id: "9", name: "iii", value: "iii", relation: "2009" },
            { id: "10", name: "aaaaaa", value: "aaaaaa", relation: "2010" },
            { id: "11", name: "aaabbb", value: "aaabbb", relation: "2011" },
            { id: "12", name: "bbbccc", value: "bbbccc", relation: "2012" },
            { id: "13", name: "cccddd", value: "cccddd", relation: "2013" },
            { id: "14", name: "dddeee", value: "dddeee", relation: "2014" },
            { id: "15", name: "eeefff", value: "eeefff", relation: "2015" },
            { id: "16", name: "fffggg", value: "fffggg", relation: "2016" },
            { id: "17", name: "ggghhh", value: "ggghhh", relation: "2017" },
            { id: "18", name: "hhhiii", value: "hhhiii", relation: "2018" },
            { id: "19", name: "iiijjj", value: "iiijjj", relation: "2019" }
          ],
          placeholder: "Please enter your name",
          required: true,
          relation: "year",
          error: "This field is required"
        }
      },
      {
        type: "question",
        stepName: "Your Built",
        title: "Is this your car's year range?",
        label: "Based on your selection, your car’s year range is: ${year}. Is this correct?",
        field: {
          key: 'year built',
          type: "radio",
          options: [
            { id: "1", name: "Yes", value: "yes" },
            { id: "2", name: "No", value: "no" }
          ],
          placeholder: "Type or select your car brand & model here...",
          required: true,
          error: "This field is required"
        }
      },
      {
        type: "question",
        stepName: "Your Device",
        title: "Choose your device type",
        label: "Do you use Android or Apple?",
        field: {
          key: 'device',
          type: "radio",
          options: [
            { id: "1", name: "Android", value: "android" },
            { id: "2", name: "Apple", value: "apple" }
          ],
          required: true,
          error: "This field is required"
        }
      },
      {
        type: "submit",
        stepName: "Your Email",
        title: "What's your email?",
        label: "Please enter your email address",
        field: {
          key: "email",
          type: "input",
          regex: "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$",
          placeholder: "Type your email here...",
          required: true,
          error: "Please enter a valid email address"
        },
        agree: "I'd also like to receive exclusive updates and discounts"
      },
      {
        type: "result",
        stepName: "Result",
        title: "You're All Set!",
        label: "Thank you for completing the questionnaire!",
        button: "Go to Purchase",
        returnto: "/"
      }
    ]
  });
});